import React, { ReactNode } from 'react';
import css from '../index.module.css';

interface Props {
  children?: ReactNode;
  theme?: string;
  dataName?: string;
}

export default function DashboardCard({
  children,
  theme = null,
  dataName = '',
}: Props) {
  return (
    <div
      className={`${css['card']} ${theme ? css[theme] : ''}`}
      data-name={dataName}
    >
      {children}
    </div>
  );
}
